import React from 'react';

export default class Page8 extends React.Component {

    render() {

        const {pageData} = this.props;

        const pageDataSortedByValue = Object.keys(pageData?.learning_style_combination).sort(function(a,b){return pageData?.learning_style_combination[a] + pageData?.learning_style_combination[b]});

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 4: Prioritise your learning style
                                                combinations
                                            </div>
                                            <p>This stage will list your learning styles in order of preference.
                                                The higher the combined score,
                                                the more likely it is to be your favourite and most effective
                                                style.</p>
                                            <p>Use the following table to prioritise your learning styles. Enter
                                                the title of the highest scoring
                                                combination, followed by its score, for example ‘Sponge’ 25.</p>

                                            <table cellspacing="0" cellpadding="0" border="0" width="100%"
                                                   className="ilead_v_sport  tablesrink">
                                                <tbody>
                                                <tr>
                                                    <th width="7%" align="left" valign="top"
                                                        className="green_curve">Priority
                                                    </th>
                                                    <th width="40%" align="left" valign="top">Learning Style
                                                        Combinations
                                                    </th>
                                                    <th width="10%"
                                                        align="center"
                                                        valign="top"
                                                        className="green_curve1"
                                                        style={{textAlign:'center'}}>Total
                                                    </th>
                                                </tr>

                                                {pageDataSortedByValue.slice(0, 10).map((value, key) => <tr key={key}>
                                                    <td width="7%" align="left" valign="top" className="lightgreen">{key + 1}
                                                    </td>
                                                    <td width="7%" align="left" valign=" top" className="lightgreen   ">
                                                        <div className="text-capitalize" align="left">{value.replace('_', ' ')}
                                                        </div>
                                                    </td>
                                                    <td width="7%" align="center" valign=" top"
                                                        className="lightgreen   ">
                                                        <div align="center">{pageData?.learning_style_combination?.[value]}</div>
                                                    </td>
                                                </tr>)}

                                                </tbody>
                                            </table>
                                            <div className=" paraspace"><p>The table on the following page provides a
                                                summary of each learning style combination. Using
                                                this information consider your priority learning styles. The
                                                following questions may help you to
                                                clarify your thoughts:</p></div>
                                            <ul className=" greenbullet-list">
                                                <li>Which style do you tend to use the most?</li>
                                                <li>Which style for you is most effective?</li>
                                                <li>Does your style vary across different situations?</li>
                                                <li>How can you capitalise on your preferred learning style(s) to
                                                    ensure you learn in the
                                                    best way for you?
                                                </li>

                                            </ul>


                                            <div className=" left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}